import { render } from "./StudyListTemplate.vue?vue&type=template&id=4f20df3c&scoped=true"
import script from "./StudyListTemplate.vue?vue&type=script&lang=js"
export * from "./StudyListTemplate.vue?vue&type=script&lang=js"

import "./StudyListTemplate.vue?vue&type=style&index=0&id=4f20df3c&scoped=true&lang=css"

import exportComponent from "D:\\agents\\Oreo\\_work\\93\\s\\NcasReporting\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f20df3c"]])

export default __exports__